import {
  Box,
  Button,
  CopyToClipboard,
  FlexBox,
  Text,
} from '@dixa/lib-shared-habla';

import { DocumentationLink } from '../documentationLink/documentationLink';

interface MobileSetupProps {
  messengerToken: string;
}

export function MobileSetup({ messengerToken }: MobileSetupProps): JSX.Element {
  return (
    <FlexBox flexDirection="column" gap="300">
      <Text.Paragraph variant="3" subdued>
        Messenger token
      </Text.Paragraph>
      <pre>{messengerToken}</pre>
      <DocumentationLink />
      <Box>
        <CopyToClipboard textToCopy={messengerToken}>
          <Button icon="copy">Copy Messenger Token</Button>
        </CopyToClipboard>
      </Box>
    </FlexBox>
  );
}
